<template>
  <div class="payProduct-wrap">
    <mu-grid-list :cols="cols" style="margin-top:10px; margin:0;">
      <mu-grid-tile v-for="(day,index) in pLists" :key="index" style="height:60px;padding:0;margin-bottom: 20px;" >
        <div class="show-day" :class="{'select-day': selected==index}" @click="selectDay(index,day)">
          <div v-if="day.label" class="triangle_border_right">
          </div>
          <div v-if="day.label" class="vip-item" v-html="day.label">
          </div>
          <div style="font-size:20px;margin-left:10px;margin-right:8px;" class="price">￥<span style="font-size:36px;">{{parseInt(day.price * day.count)}}</span></div>
          <div class="day-items" style="vertical-align: middle;">
            <span>{{day.count}}天</span><span v-if="day.gift_days > 0">+送{{day.gift_days}}天</span><br/>
            <span>日均￥{{day.average_daily_price}}/天</span>
          </div>
          <!-- <p class="survice">赠送条件：首次训练起，{{day.days}}天内累计训练超过{{day.over_day}}天，赠送{{day.days}}天</p> -->
        </div>
      </mu-grid-tile>
    </mu-grid-list>
  </div>
</template>

<script>
import Vue from "vue"
import {mapState} from 'vuex'
export default {
  data () {
    return {
      cols: 3,
      pLists: [],
      pro_id:"",
      selectedId:"",
    }
  },
  props:["orgId"],
  created(){
    //初始化selected
    this.$store.commit("setSelected",0);
    this.getProduct(this.orgId);
  },
  computed:{
    ...mapState(["selected","quantity"])
  },
  watch:{
    quantity(val){
      this.pLists.forEach((item) => {
        if(item.id == this.selectedId){
          item.count = val;
        }
      })
    }
  },
  methods: {
    // 获取产品列表，即选择订单天数
    getProduct(orgId){
      this.$http.get(GLOBAL.ORDER + "goods/" + orgId + "/available",
        {emulateJSON: false})
      .then((res) => {
        var arr = res.data.need_pay;
        arr.forEach((item) => {
          this.$store.commit('changeQuantity', item.min_num);
          /* quantity 注入到商品列表中 */
          this.$set(item,'count',this.quantity);
        })
        this.pLists = arr;
        if(this.pLists.length > 0){
          this.selectDay(0, this.pLists[0]);
        }
      })
    },
    addIpad(){
      for(var i=0; i < this.pLists.length; i++){
        if(this.pLists[i].ipad){
          this.pLists[i].price = 6400;
        }
      }
    },
    reduceIpad(){
      for(var i=0; i < this.pLists.length; i++){
        if(this.pLists[i].ipad){
          this.pLists[i].price = 5400;
        }
      }
    },
    selectDay(val,day){
      this.selectedId = day.id;
      this.$store.commit('changeQuantity', day.min_num);
      //切换天数标签的高亮显示
      this.$store.commit("setSelected",val);
      //切换天数标签时，康复天数切换到对应天数
      //2.5.1去掉标签和康复天数的关联
      this.$store.commit("getDay","");
      this.$emit("selectDay",day);
    }
  }
}
</script>
<style scoped lang="stylus">
.payProduct-wrap
  height 170px
  width 740px
  overflow auto
.show-day
  position relative
  border 1px solid #eee;
  color #444
  margin-left 10px
  margin-right 10px
  height 60px
  width 235px
  border-radius 5px
  cursor pointer
  font-size 0

.show-day:first-child
  margin-left 0


.day-items
  position relative
  display inline-block
  width 89px
  height 36px
  font-size 12px


.price
  display inline-block
  color #0A81E5
  height 60px
  line-height 60px
  vertical-align middle

.select-day
  background-color #0a81e5
  color #fff
  margin 0

.select-day .days
  color #fff

.select-day .price
  color #fff;

p
  margin 0
  text-align center

.days
  color #FF5C00
  margin-top 10px

.survice
  width 100% 
  font-size 14px
  margin-top 10px
  text-align left
  padding 0 20px
  color #999999

.select-day .survice
  color #fff

.items-price
  position absolute 
  top 0
  height 16px

.items-pre_day
  position absolute 
  top 0
  height 16px

.vip-item
  position absolute
  left -2px
  top 0px
  transform rotate(-45deg)
  width 42px
  height 38px
  background-color rgba(0,0,0,0)
  z-index 2
  font-size 12px
  color #fff
  text-align  center
  line-height 12px

.triangle_border_right{
    position: absolute;
    top:-6px;
    left:-22px;
    width:0;
    height:0;
    border-top:34px solid #E75710;
    border-left: 34px solid #E75710;
    border-right: 34px solid #E75710;
    transform:rotate(135deg);
    z-index:1;
}


</style>




// WEBPACK FOOTER //
// payProduct.vue?b7bff01a